export default "__VITE_ASSET__9Aa3EAl7__"